import * as Yup from "yup";
import { Cancel } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { Formik } from "formik";
import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { DateRange } from "react-date-range";

import { useAxios } from "../../../hooks";

const useStyles = makeStyles(() => ({
  paper: { minWidth: "425px" },
}));

export default function GenerateReportDialog({
  generateList,
  generateReportDialog,
  setGenerateReportDialog,
}) {
  const axios = useAxios();
  const classes = useStyles();
  const { activeBot } = useSelector((state) => state.memberDetails);

  const [formData, setFormData] = useState({
    startDate: "",
    endDate: "",
    dateRange: [],
  });
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  function handleClose() {
    setGenerateReportDialog(false);
  }

  const validationSchema = Yup.object().shape({
    startDate: Yup.number().required("Start Date is required."),
    endDate: Yup.number().required("End Date is required."),
  });

  return (
    <Dialog
      open={generateReportDialog}
      onClose={handleClose}
      classes={{ paper: classes.paper }}
    >
      <DialogContent>
        <Grid
          container
          spacing={0}
          style={{
            borderBottom: "1px solid #cbcbcb",
          }}
        >
          <Grid style={{ padding: "16px 24px" }} item xs={8}>
            <Typography variant="h5">Generate Chat Report</Typography>
          </Grid>

          <Grid item xs={4}>
            <IconButton
              disableRipple
              style={{ float: "right", padding: "16px 24px" }}
              onClick={handleClose}
            >
              <Cancel />
            </IconButton>
          </Grid>
        </Grid>

        <Formik
          initialValues={formData}
          validationSchema={validationSchema}
          onSubmit={(formData, { setSubmitting }) => {
            axios({
              url: "/insights/logs-request",
              method: "POST",
              data: {
                agent_id: activeBot.ID,
                is_conversation:
                  activeBot.channel !== "whatsapp" ? true : false,
                is_whatsapp: activeBot.channel === "whatsapp" ? true : false,
                start_time: formData.startDate,
                end_time: formData.endDate,
              },
            }).then((response) => {
              if (response.status) {
                generateList();
                handleClose();
              }
            });
          }}
        >
          {(formikProps) => {
            function handleChange(item) {
              setState([item.selection]);
              const timestamp1 = new Date(item.selection.startDate).getTime();
              const timestamp2 = new Date(item.selection.endDate).getTime();

              formikProps.setFieldValue("startDate", timestamp1 / 1000);
              formikProps.setFieldValue(
                "endDate",
                (timestamp2 + 3600 * 1000 * 24) / 1000
              );
            }

            return (
              <React.Fragment>
                <Grid container justifyContent={"space-evenly"}>
                  <Grid item sx={{ pl: "25px", pt: "25px" }}>
                    <Grid item mb={2}>
                      <Typography variant="caption1">
                        Select Start Date And End Date
                      </Typography>
                    </Grid>

                    <Grid>
                      <DateRange
                        ranges={state}
                        onChange={(items) => handleChange(items)}
                      ></DateRange>
                    </Grid>
                  </Grid>
                </Grid>

                <DialogActions style={{ padding: "12px 25px 24px" }}>
                  <Grid
                    container
                    spacing={3}
                    display={"flex"}
                    justifyContent={"end"}
                  >
                    <Grid item>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleClose}
                      >
                        Cancel
                      </Button>
                    </Grid>

                    <Grid item>
                      <Button
                        onClick={formikProps.handleSubmit}
                        variant="contained"
                        color="primary"
                        disabled={!formikProps.dirty || !formikProps.isValid}
                      >
                        Generate Report
                      </Button>
                    </Grid>
                  </Grid>
                </DialogActions>
              </React.Fragment>
            );
          }}
        </Formik>
      </DialogContent>
    </Dialog>
  );
}
